<div
  class="search-dropdown-wrapper !flex flex-row gap-[8px] justify-start items-center"
  *ngIf="departments"
>
  <mat-form-field mat-select-height-large class="search-dropdown" data-at-department>
    <mat-label>{{ '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.DEPARTMENT' | translate }}</mat-label>
    <mat-select
      [disabled]="!isSupportInternationalRoleActive"
      [(ngModel)]="departmentModel"
      [compareWith]="compareObjects"
      fieldTextContentTooltip
    >
      <mat-option class="hidden-option" [value]="{ name: null }" fieldTextContentTooltip>{{
        '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.NOT_ASSIGNED' | translate
      }}</mat-option>
      <mat-option
        *ngFor="let department of departments"
        [value]="department"
        gtm="onSelect"
        gtmAction="Department"
        gtmCategory="deviceCard"
        fieldTextContentTooltip
        >{{ department.name }}</mat-option
      >
    </mat-select>
  </mat-form-field>
  <button
    [matTooltip]="'+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SAVE_DEPARTMENT_TOOLTIP' | translate"
    *ngIf="isSupportInternationalRoleActive"
    gtm="onSave"
    gtmAction="New device`s department name"
    gtmCategory="deviceCard"
    mat-icon-button
    (click)="saveNewDepartmentName(departmentModel.name)"
    [disabled]="!departmentModel || savedDepartmentName === departmentModel.name"
  >
    <mat-icon>save</mat-icon>
  </button>
  <button
    [matTooltip]="'+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNASSIGN_DEPARTMENT_TOOLTIP' | translate"
    *ngIf="isSupportInternationalRoleActive"
    mat-icon-button
    gtm="onDelete"
    gtmAction="Device`s department"
    gtmCategory="deviceCard"
    (click)="deleteDepartment()"
    [disabled]="!departmentModel || !savedDepartmentName"
  >
    <mat-icon>clear</mat-icon>
  </button>
</div>
